import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

/**
 * Resolve refund_id if parameter refund_id value is refund_number (uuid)
 */
const resolveRefundId = getters => {
    let refund_id = getters.receipt.refund_id;

    // is uuid
    if (refund_id && refund_id.length === 36) {
        // find refund_id by uuid
        const refundProduct = getters.receipt.refund_products.find(
            rp => rp.refund && rp.refund.refund_number === refund_id,
        );

        if (refundProduct) {
            refund_id = refundProduct.refund_id;
        }
    }

    return refund_id;
};

const getters = {
    hasTransaction: state => {
        return state.transaction.id !== null;
    },

    hasTable: state => {
        return state.transaction.order.table !== null;
    },

    receipt: state => {
        return state.transaction.receipt;
    },

    isVoided: state => {
        return (
            state.transaction.receipt.voided_at !== null &&
            state.transaction.receipt.voided == true
        );
    },

    table: state => {
        let table = state.transaction.order.table;
        if (table != null) {
            return table.table;
        } else {
            return null;
        }
    },

    order: state => {
        return state.transaction.order;
    },

    orderFuel: state => {
        return state.transaction.order.fuel;
    },

    orderTable: state => {
        return state.transaction.order.table;
    },

    orderCharges: state => {
        return state.transaction.order.charges;
    },

    orderTaxes: state => {
        return state.transaction.order.taxes;
    },

    /**
     * @return {Array}
     */
    orderProducts: state => {
        return state.transaction.order.products;
    },

    cancelledOrderProducts: (state, getters) => {
        return getters.orderProducts.filter(p => p.cancelled_at);
    },

    purchasedOrderProducts: (state, getters) => {
        return getters.orderProducts.filter(
            p => _.isEmpty(p.discounts) && !p.cancelled_at,
        );
    },

    purchasedOrderFuels: (state, getters) => {
        return getters.orderFuels.filter(f => _.isEmpty(f.discounts));
    },

    orderDiscounts: state => {
        return state.transaction.order.discounts;
    },

    orderProductDiscounts: state => {
        let orderProductDiscounts = state.transaction.order.products
            .map(product => {
                return product.discounts;
            })
            .filter(product => {
                return product.length;
            });

        let flatOrderProductDiscounts = _.flatten(orderProductDiscounts);

        let data = [];

        flatOrderProductDiscounts.map(product => {
            const index = data.findIndex(
                p => p.product_id === product.product_id,
            );

            if (index !== -1) {
                data[index].applied_amount =
                    parseFloat(data[index].applied_amount) +
                    parseFloat(product.applied_amount);

                data[index].discounts.push(product.discount);
            } else {
                product.discounts = [product.discount];
                data.push(product);
            }
        });

        return data;
    },

    transaction: state => {
        return state.transaction;
    },

    outlet: state => {
        return state.transaction.receipt.outlet;
    },

    cashier: state => {
        return state.transaction.receipt.cashier;
    },

    charges: state => {
        return state.transaction.receipt.charges;
    },

    taxes: state => {
        return state.transaction.receipt.taxes;
    },

    voider: (state, getters) => {
        return getters.receipt.voided_staff;
    },

    /**
     * @return {Array}
     */
    discounts: state => {
        let receiptDiscounts = state.transaction.receipt.discounts;

        return receiptDiscounts.map(obj => {
            let name =
                obj.discount == null
                    ? obj.name
                        ? obj.name
                        : obj.remarks
                    : obj.discount.name;

            return {
                name: name,
                amount: obj.amount,
                remarks: obj.remarks,
            };
        });
    },

    fuel: state => {
        return state.transaction.order.fuel;
    },

    orderFuels: state => {
        return state.transaction.order.fuels;
    },

    payments: state => {
        let receiptPayments = state.transaction.receipt.payments;

        return receiptPayments.map(obj => {
            let reference_number = obj.reference_number;
            let original_approval_code = null;
            let approval_code = null;
            let ref_number = null;
            let stan_no = null;

            if (!_.isNull(reference_number)) {
                reference_number = reference_number.split('|')[0];
            }

            if (!_.isEmpty(obj.meta)) {
                if (!_.isUndefined(obj.meta.approval_code)) {
                    if (!_.isNull(obj.meta.original_approval_code)) {
                        original_approval_code =
                            obj.meta.original_approval_code;
                    }

                    approval_code = obj.meta.approval_code;
                } else if (!_.isUndefined(obj.meta.b_approval)) {
                    approval_code = obj.meta.b_approval;
                }

                if (!_.isNull(obj.meta.ref)) {
                    ref_number = obj.meta.ref;
                }

                if (!_.isNull(obj.meta.site_tran_no)) {
                    stan_no = obj.meta.site_tran_no;
                }
            }

            return {
                name: obj.payment.name,
                amount: obj.amount,
                reference_number: reference_number,
                card: obj.card,
                original_amount: obj.original_amount,
                type: obj.payment.type,
                original_approval_code: original_approval_code,
                approval_code: approval_code,
                ref_number: ref_number,
                stan_no: stan_no,
                remarks: obj.remarks,
                ewallet: obj.ewallet,
                terminal_id: obj.terminal_id,
                terminal_type: obj.terminal_type,
            };
        });
    },

    /**
     * @return {Float}
     */
    totalDiscount: state => {
        let receiptDiscounts = state.transaction.receipt.discounts;
        let totalDiscount = 0;

        receiptDiscounts.forEach(obj => {
            totalDiscount += parseFloat(obj.amount);
        });

        return totalDiscount;
    },

    totalAfterDiscount: (state, getters) => {
        return numeral(
            parseFloat(getters.receipt.amount) + getters.totalDiscount,
        ).format();
    },

    /**
     * @return {Float}
     */
    totalChange: (state, getters) => {
        let totalChange = 0;

        getters.receipt.payments.forEach(p => {
            totalChange += !_.isNull(p.change) ? parseFloat(p.change) : 0;
        });

        return numeral(totalChange).format();
    },

    paymentName: (state, getters) => {
        return getters.payments.map(p => p.name.toLowerCase());
    },

    subTotal: (state, getters) => {
        let receipt = getters.receipt;

        let amount = receipt.amount;

        let refund = receipt.refunds
            .map(f => {
                return parseFloat(f.amount);
            })
            .reduce((a, b) => a + b, 0);

        let subTotal = parseFloat(amount) + parseFloat(refund);

        return subTotal.toFixed(2);
    },

    grandTotal: (state, getters) => {
        let receipt = getters.receipt;

        let amount = receipt.total_amount;

        let refund = receipt.refunds
            .map(f => {
                return parseFloat(f.total_amount);
            })
            .reduce((a, b) => a + b, 0);

        let grandTotal = parseFloat(amount) + parseFloat(refund);

        return grandTotal.toFixed(2);
    },

    totalSaving: (state, getters) => {
        let order = getters.order;

        return Math.abs(
            order.discounts
                .map(d => {
                    return parseFloat(d.applied_amount);
                })
                .reduce((a, b) => a + b, 0),
        ).toFixed(2);
    },

    returnedOrderProducts: (state, getters) => {
        const refund_id = resolveRefundId(getters);

        return getters.receipt.refund_products
            .filter(f => f.refund_id <= refund_id)
            .map(f => {
                f.product.unit_price = f.amount;
                f.product.quantity = f.quantity;
                f.product.refund = true;
                f.product.refunded_at = f.refund.refunded_at;

                return f.product;
            })
            .sort((a, b) => {
                return moment(b.refunded_at) - moment(a.refunded_at);
            });
    },

    rounding: (state, getters) => {
        let receipt = getters.receipt;

        let receiptRounding = receipt.rounding;

        let refundRounding = receipt.refunds
            .map(f => {
                return parseFloat(f.rounding);
            })
            .reduce((a, b) => a + b, 0);

        let rounding = parseFloat(receiptRounding) + refundRounding;

        return rounding.toFixed(2);
    },

    returnSubTotal: (state, getters) => {
        let receipt = getters.receipt;

        let refund = receipt.refunds.filter(
            f => f.id <= resolveRefundId(getters),
        );

        let amount = refund
            .map(f => {
                return parseFloat(f.amount);
            })
            .reduce((a, b) => a + b, 0);

        return amount.toFixed(2);
    },

    returnGrandTotal: (state, getters) => {
        let receipt = getters.receipt;

        let refund = receipt.refunds.filter(
            f => f.id <= resolveRefundId(getters),
        );

        let total_amount = refund
            .map(f => {
                return parseFloat(f.total_amount);
            })
            .reduce((a, b) => a + b, 0);

        return total_amount.toFixed(2);
    },

    returnRounding: (state, getters) => {
        let receipt = getters.receipt;

        let refund = receipt.refunds.filter(
            f => f.id <= resolveRefundId(getters),
        );

        let rounding = refund
            .map(f => {
                return parseFloat(f.rounding);
            })
            .reduce((a, b) => a + b, 0);

        return rounding.toFixed(2);
    },

    firstTransaction: state => state.firstTransaction,
};

const state = {
    transaction: {
        id: null,
        receipt: {
            discounts: [],
            payments: [],
            taxes: [],
            refund_id: null,
            voided: false,
        },
        order: {
            products: [],
            table: {
                table: null,
            },
        },
    },
    filters: [],
    searchMeta: null,
    staffList: [],
    firstTransaction: null,
};

const mutations = {
    setFilters(state, filters) {
        state.filters = filters;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setStaffList(state, data) {
        state.staffList = data;
    },

    [type.SET_TRANSACTION](state, transaction) {
        state.transaction = transaction;
    },

    [type.SET_REFUND_ID](state, refund_id) {
        state.transaction.receipt.refund_id = refund_id;
    },

    [type.SET_VOIDED](state, voided) {
        state.transaction.receipt.voided = voided;
    },

    setFirstTransaction(state, data) {
        state.firstTransaction = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        startLoading(dispatch, 'get-transaction-meta');

        return axios
            .get(Laroute.route('franchise.report.transaction.meta'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-transaction-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-transaction-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getSearchMetaV2({ commit, dispatch }) {
        startLoading(dispatch, 'get-transaction-meta');

        return axios
            .get(Laroute.route('franchise.report.transaction.meta.V2'))
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-transaction-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-transaction-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessaryV2({ dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMetaV2');
        }

        return Promise.resolve(state.searchMeta);
    },

    getTransaction(
        { dispatch, commit },
        { id, refund_id, voided, receipt_number },
    ) {
        startLoading(dispatch, 'fetch-transaction');

        let params = { id: id };

        if (receipt_number != undefined) {
            params = { id: id, receipt_number: receipt_number };
        }

        let url = Laroute.route(
            'franchise.report.transaction.getTransactionReceipt',
            params,
        );

        axios
            .get(url)
            .then(res => {
                endLoading(dispatch, 'fetch-transaction');

                let data = res.data.data;
                commit(type.SET_TRANSACTION, data);

                if (!_.isNull(refund_id)) {
                    commit(type.SET_REFUND_ID, refund_id);
                }

                if (voided) {
                    commit(type.SET_VOIDED, voided);
                }

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-transaction');

                throw err;
            });
    },

    async getFirstTransaction({ dispatch, commit }, outletId) {
        startLoading(dispatch, 'first-transaction');

        let url = Laroute.route('franchise.report.transaction.first', {
            outletId,
        });

        axios
            .get(url)
            .then(res => {
                endLoading(dispatch, 'first-transaction');

                commit('setFirstTransaction', res.data);

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'first-transaction');

                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/transaction.js